import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";
import { FormatHelper } from '../../../../../assets/utils/helpers/formatHelper';

export interface ControlCurrencyProps extends ControlTemplateProps {

}


export const ControlCurrency: React.FC<ControlCurrencyProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ?? useControlStyles();

    const formatCurrency = (input: any, blur?: boolean) => {

        let input_val = input.value;
        if (input_val === "") { return; }
        let original_len = input_val.length;

        let caret_pos = input.selectionStart;
        input_val = FormatHelper.formatCurrencyValue(input_val, blur);

        // send updated string to input
        input.value = input_val;

        // put caret back in the right position
        var updated_len = input_val.length;
        caret_pos = updated_len - original_len + caret_pos;
        input.setSelectionRange(caret_pos, caret_pos);
    }

    return (
        <ControlInput
            type="text"
            {...ComponentProps(props)}
            style={{ ...styles.number ?? styles.text ?? styles.input, ...props.style }}
            onBlur={(e: any) => formatCurrency(e.target, true)}
            onChange={(e: any) => formatCurrency(e.target)}

        />
    );
};